import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class CustomServices extends Component {
  render () {
    return (
      <div className='container-services-banners container-fluid bg-brand-4 blue-area pt-0 pb-5 py-md-5'>
        <div className='container py-1'>
          <div className='row'>
            <div className='banner-illustration col-12 col-md-6 my-3 my-md-0' />
            <div className='banner-service-items col-12 col-md-6'>
              <div className='row'>
                <div className='banner-service-item col-12 col-md-6'>
                  <div className='row mx-0'>
                    <div className='banner-service-item-inner col-12 mb-1'>
                      <div className='row h-100'>
                        <div className='col-12 col-md-11 py-2 px-2'>
                          <h3>Transferência de pontos</h3>
                        </div>
                        <div className='col-12 align-self-end py-2' >
                          <div className='row'>
                            <div className='col-12 px-2'>
                              <Link
                                to='/'
                                className='btn btn-sm txt-center txt-initial'
                                role='link' disabled='disabled'
                              >
                                Em Breve
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div className='banner-service-item col-12 col-md-6'>
                  <div className='row mx-0'>
                    <div className='banner-service-item-inner col-12 mb-1'>
                      <div className='row h-100'>
                        <div className='col-12 col-md-11 py-2 px-2'>
                          <h3>Doação de pontos</h3>
                        </div>
                        <div className='col-12 align-self-end py-2' >
                          <div className='row'>
                            <div className='col-12 px-2'>
                              <Link
                                to='/vendor?vendor=61912'
                                className='btn btn-sm txt-center txt-initial'
                                role='link'
                              >
                                Doar
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div className='banner-service-item col-12 col-md-6'>
                  <div className='row mx-0'>
                    <div className='banner-service-item-inner col-12 mt-1'>
                      <div className='row h-100'>
                        <div className='col-12 col-md-11 py-2 px-2'>
                          <h3>Crédito em combustível</h3>
                        </div>
                        <div className='col-12 align-self-end py-2' >
                          <div className='row'>
                            <div className='col-12 px-2'>
                              <Link
                                to='/fuelcredit'
                                className='btn btn-sm txt-center txt-initial'
                                role='link'
                              >
                                Abastecer
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div className='banner-service-item col-12 col-md-6'>

                  <div className='row mx-0'>
                    <div className='banner-service-item-inner col-12 mt-1'>
                      <div className='row h-100'>
                        <div className='col-12 col-md-11 py-2 px-2'>
                          <h3>Recarga de celular</h3>
                        </div>
                        <div className='col-12 align-self-end py-2' >
                          <div className='row'>
                            <div className='col-12 px-2'>
                              <Link
                                to='/mobile-recharge'
                                className='btn btn-sm txt-center txt-initial'
                                role='link'
                              >
                                Recarregar
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

export default CustomServices



// WEBPACK FOOTER //
// ./src/features/Services/CustomServices.js